import React, { useEffect, useRef } from 'react'

export const ObserverWrapper = ({ uri, children }) => {
  const currentRef = useRef(null)

  useEffect(() => {
    let options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.05,
    }
    const observer = new IntersectionObserver(entities => {
      entities.forEach(entity => {
        if (entity.isIntersecting && typeof window !== undefined)
          window.history.replaceState({}, '', uri)
      })
    }, options)

    if (currentRef.current) observer.observe(currentRef.current)

    return () => observer.disconnect()
  }, [currentRef, uri])

  return <div ref={currentRef}>{children}</div>
}
